import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { EscalatingReportService } from '../../../services/reports/escalating-report.service';
import { MissedRecallAction } from './missed-recall-action.service';

/**
 * https://www.intertech.com/Blog/ngrx-tutorial-actions-reducers-and-effects/
 * https://medium.com/frontend-fun/angular-ngrx-a-clean-and-clear-introduction-4ed61c89c1fc
 */

@Injectable()
export class MissedRecallEffect {

    constructor(private actions$: Actions,
                private escalatingReportService: EscalatingReportService) {
    }

    getEscalatingReport$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType(MissedRecallAction.getEscalateReport),
                switchMap(action =>
                    this.escalatingReportService.getEscalatingReport(action.searchParameters)
                        .pipe(
                            map(reports => MissedRecallAction.getEscalateReportSuccess(reports)
                            )

                            /* catchError(error =>
                                of(MissedAndRecallAction.getEscalateReportFailed({error}))
                            )*/
                        )
                )
            )
    );

}
